import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default [{
  path: "/billing_Zone",
  component: function component() {
    return import("../../../views/cloud_shop/billing_Zone.vue");
  },
  name: "billing_Zone",
  meta: {
    title: "开单专区",
    foot: true
  }
},
// 排行榜
{
  path: "/cloud_shop_rank",
  component: function component() {
    return import("../../../views/cloud_shop/cloud_shop_rank.vue");
  },
  name: "cloud_shop_rank",
  meta: {
    title: "排行榜",
    foot: true
  }
},
// 满返跟超品共用一个页面
{
  path: "/full_Return_Details/:id",
  component: function component() {
    return import("../../../views/cloud_shop/full_Return_Details.vue");
  },
  name: "full_Return_Details",
  meta: {
    title: "满返详情",
    foot: true
  }
},
// 活动商品列表
{
  path: "/full_Return_Details_list/:id?",
  component: function component() {
    return import("../../../views/cloud_shop/full_Return_Details_list.vue");
  },
  name: "full_Return_Details_list",
  meta: {
    title: "活动商品列表",
    foot: true
  }
},
// 品牌墙
{
  path: "/brand_wall",
  component: function component() {
    return import("../../../views/cloud_shop/brand_wall.vue");
  },
  name: "brand_wall",
  meta: {
    title: "品牌墙",
    foot: true
  }
},
// 品牌首页
{
  path: "/brand_home/:id?",
  component: function component() {
    return import("../../../views/cloud_shop/brand_home.vue");
  },
  name: "brand_home",
  meta: {
    title: "品牌首页",
    foot: true
  }
},
// 品牌素材
{
  path: "/brand_source_material/:id?",
  component: function component() {
    return import("../../../views/cloud_shop/brand_source_material.vue");
  },
  name: "brand_source_material",
  meta: {
    title: "品牌素材",
    foot: true
  }
},
// 素材详情
{
  path: "/brand_source_detail/:id?",
  component: function component() {
    return import("../../../views/cloud_shop/brand_source_detail.vue");
  },
  name: "brand_source_detail",
  meta: {
    title: "素材详情",
    foot: true
  }
},
// 实习指引
{
  path: "/internship_Guide",
  component: function component() {
    return import("../../../views/cloud_shop/internship_Guide.vue");
  },
  name: "internship_Guide",
  meta: {
    title: "实习指引详情",
    foot: true
  }
},
// 邀请码
{
  path: "/Invitation_code",
  component: function component() {
    return import("../../../views/cloud_shop/Invitation_code.vue");
  },
  name: "Invitation_code",
  meta: {
    title: "邀请码",
    foot: true
  }
}, {
  path: "/Invitation_code_inp",
  component: function component() {
    return import("../../../views/cloud_shop/Invitation_code_inp.vue");
  },
  name: "Invitation_code_inp",
  meta: {
    title: "输入邀请码",
    foot: true
  }
}, {
  path: "/cloud_shop/agreement",
  component: function component() {
    return import("../../../views/cloud_shop/cloud_shop_agreement.vue");
  },
  name: "cloud_shop_agreement",
  meta: {
    title: "邀请码协议",
    foot: true
  }
}, {
  path: "/Invitation_code_list",
  component: function component() {
    return import("../../../views/cloud_shop/Invitation_code_list.vue");
  },
  name: "Invitation_code_list",
  meta: {
    title: "生成记录",
    foot: true
  }
},
//我的顾客
{
  path: "/customersMy",
  component: function component() {
    return import("../../../views/cloud_shop/customersMy.vue");
  },
  name: "customersMy",
  meta: {
    title: "我的顾客",
    foot: true
  }
},
// 顾客详情
{
  path: "/customersDetail/:id?",
  component: function component() {
    return import("../../../views/cloud_shop/customersDetail.vue");
  },
  name: "customersDetail",
  meta: {
    title: "顾客详情",
    foot: true
  }
},
// 我的收益 - 奖励中心
{
  path: "/cloud_shop_reward_center",
  component: function component() {
    return import("../../../views/cloud_shop/cloud_shop_reward_center.vue");
  },
  name: "cloud_shop_reward_center",
  meta: {
    title: "奖励中心",
    foot: true
  }
},
// 我的销售
{
  path: "/mysales",
  component: function component() {
    return import("../../../views/cloud_shop/mysales.vue");
  },
  name: "mysales",
  meta: {
    title: "我的销售",
    foot: true
  }
},
//  品牌销售
{
  path: "/brandSales",
  component: function component() {
    return import("../../../views/cloud_shop/brandSales.vue");
  },
  name: "brandSales",
  meta: {
    title: "品牌销售",
    foot: true
  }
}, {
  path: "/brandSales_new",
  component: function component() {
    return import("../../../views/cloud_shop/brandSales.vue");
  },
  name: "brandSales_new",
  meta: {
    title: "畅销品牌",
    foot: true
  }
},
//我的服务 - 意见反馈记录
{
  path: "/Feedback_record/:id",
  component: function component() {
    return import("../../../views/cloud_shop/Feedback_record.vue");
  },
  name: "Feedback_record",
  meta: {
    title: "意见反馈记录",
    foot: true
  }
},
// 添加导师 后台上传图片
{
  path: "/cloud_shop_diyPage",
  component: function component() {
    return import("../../../views/cloud_shop/cloud_shop_diyPage.vue");
  },
  name: "cloud_shop_diyPage",
  meta: {
    title: "官方导师",
    foot: true
  }
}, {
  path: "/cloud_shop_sharePage/:brand_id?/:brand_collect_id?",
  component: function component() {
    return import("../../../views/cloud_shop/cloud_shop_sharePage.vue");
  },
  name: "cloud_shop_sharePage",
  meta: {
    title: "分享",
    foot: true
  }
}];